import React from 'react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import {Menu, Icon, Label} from 'semantic-ui-react';

import Utils from 'utils/Utils.js';
import {colors, shadow, fontSizes, spacings, layout} from 'style';
import bellIcon from 'img/musical-bell-outline.png';
import PopUpMenuContainer from './PopUpMenuContainer.js';

var style = {
    menu: {
        width: '100vw',
        borderRadius: '0',
        backgroundColor: colors.themeBlue,
        height: '100%',
        marginTop: '0px',
    },
    resourcesLink: {
        color: '#fff',
        backgroundColor: 'rgba(0,0,0,0)',
        padding: '5px 10px 5px 5px',
        margin: '-2px -8px -2px -8px',
        borderRadius: '20px',
        border: '1px solid white',
    },
    pointsLink: {
        color: '#fff',
        backgroundColor: 'rgba(0,0,0,0)',
        padding: '5px 10px 5px 5px',
        margin: '-2px -8px -2px -8px',
        borderRadius: '20px',
        border: '1px solid white',
    },
    iconWrapper: {
        display: 'inline-block',
        position: 'relative',
        width: '30px',
        height: '14px',
    },
    pointsIcon: {
        fontSize: '18px',
        position: 'absolute',
        top: '0px',
        left: '0px'
    },
    bellIcon: {
        width: '24px',
        height: '24px',
    },
    resourcesIcon: {
        position: 'absolute',
        top: '2px',
        left: '5px'
    },
    titleWrapper: {
        position: 'absolute',
        left: '50vw',
        top: '0',
    },
    title: {
        position: 'relative',
        left: '-50%',
        fontSize: '1.2em',
        color: '#fff',
        opacity: '1',
        paddingLeft: '0px',
        paddingRight: '0px',
    },
    icon: {
        color: '#fff',
        opacity: '1',
    },
    bold: {
        fontWeight: 'bold',
    },
    item: {
        color: '#fff',
    },
};

var modes = {
    normal: {
        menu: {
            boxShadow: 'none',
            color: '#fff',
        },
        logoWrapper: {
            display: 'none',
        },
        badgeNumber: {
            position: 'absolute',
            top:   '5px',
            right: '5px',   
        },
    },
    light: {
        menu: {
            height: '85px',
            borderRadius: '0',
            backgroundColor: '#fff',
            color: colors.themeDarkGrey,
        },
        icon: {
            color: colors.themeDarkGrey,
            opacity: '1',
        },
        title: {
            display: 'none',
        },
        logo: {
            color: colors.themeTeal,
            fontSize: fontSizes.h2,
            
            position: 'relative',
            left: '-50%',
        },
        logoWrapper: {
            position: 'absolute',
            left: '50%',
            top: '0',
            lineHeight: '85px',
        },
        item: {
            color: colors.themeDarkGrey,
        },
        badgeNumber: {
            position: 'absolute',
            top:   '5px',
            right: '5px',   
        },
    },
    main: {
        menu: {
            height: '80px',
            borderRadius: '0',
            backgroundColor: '#fff',
            color: colors.themeDarkGrey,
            boxShadow: 'none',
            borderBottom: '1px solid ' + colors.themeDarkGrey,
        },
        icon: {
            color: colors.themeDarkGrey,
            opacity: '1',
        },
        title: {
            display: 'none',
        },
        logoWrapper: {
            lineHeight: '80px',
            padding: '0px',
        },
        logo: {
            color: colors.themeTeal,
            fontSize: '32px',
            padding: spacings.base,
            position: 'relative',
            top: '1px',
        },
        item: {
            color: colors.themeDarkerGrey,
            padding: '12px',
        },
        verticalRule: {
            marginRight: '12px',
            marginTop: '16px',
            height: '48px',
            display: 'block',
            width: '2px',
            backgroundColor: colors.themeDarkGrey1_2,
        },
        avatar: {
            cursor: 'pointer',
            position: 'relative',
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            boxShadow: shadow,
            border: '2px solid #fff',
            backgroundPosition:'50% 50%', 
            backgroundSize:'cover',
            backgroundRepeat: 'no-repeat',
            marginTop: '16px',
            marginRight: spacings.base,
            marginLeft: '12px',
        },
        avatarMobile: {
            marginRight: spacings.small,
        },
        resourcesLink: {
            color: '#fff',
            backgroundColor: colors.themeBlue,
            boxShadow: shadow,
            padding: '5px 10px 5px 5px',
            margin: '-2px -8px -2px -8px',
            borderRadius: '20px',
            border: 'none',
        },
        pointsLink: {
            color: '#fff',
            backgroundColor: colors.pointsYellow,
            boxShadow: shadow,
            padding: '5px 10px 5px 5px',
            margin: '-2px -8px -2px -8px',
            borderRadius: '20px',
            border: 'none',
        },
        announcementsLink: {
            position: 'relative',
        },
        badgeNumber: {
            minWidth: '24px',
            height: '24px',
            backgroundColor: colors.warningRed,
            color: '#fff',
            lineHeight: '24px',
            textAlign: 'center',
            borderRadius: '100px',
            position: 'absolute',
            top: '28px',
            left: '50%',
            marginLeft: '-12px',
        },
        badgeNumberSpacer: {
            width: '24px',
            height: '10px',
            float: 'left',
        },
        bellIconWrapper: {
            textAlign: 'center',
            display: 'inline-block',
            position: 'relative',
            width: '24px',
            height: '14px',
        },
        closeItem: {
            position: 'absolute',
            top: '84px',
            left: '5px',
        },
        closeIcon: {
            color: colors.themeDarkerGrey,
        }
    }
};

const getStyle = (mode, ...classNames) => {
    return classNames.reduce((result, className) => ({...result, ...style[className], ...(modes[mode] && modes[mode][className])}), {});
};



const NavBarLegacy = ({m, t, ...props}) => (
    <Menu className="NavBar" style={getStyle(m, 'menu')}>
        {props.logoutButtonEnable &&
            <Menu.Item style={getStyle(m, 'item')} name='Logout' onClick={props.onSignOut}>{t('Logout')}</Menu.Item>
        }
        {props.menuEnable &&
            <Menu.Item style={getStyle(m, 'item')} name='Menu' onClick={props.onClickMenuButton}><Icon style={getStyle(m, 'icon', 'bold')} size='large' name={props.sideBarOpen ? 'x' : null} className={props.sideBarOpen ? null : 'icon-menu' }/></Menu.Item>
        }
        {props.backButtonEnable && !props.closeButtonEnable &&
            <Menu.Item style={getStyle(m, 'item')} name='Back' onClick={props.onBack}><Icon style={getStyle(m, 'icon', 'bold')} size='large' name='chevron left'/></Menu.Item>
        }
        {props.closeButtonEnable &&
            <Menu.Item style={getStyle(m, 'item')} name='Close' onClick={props.onClose}><Icon style={getStyle(m, 'icon', 'bold')} size='large' name={props.closeIconOpts ? props.closeIconOpts.name : 'x'} className={props.closeIconOpts ? props.closeIconOpts.className : ''}/></Menu.Item>
        }

        <div style={getStyle(m, 'titleWrapper')}>
            <div style={getStyle(m, 'title')} className="item right floated borderless">{props.title}</div>
        </div>
        <div style={getStyle(m, 'logoWrapper')}>
            <i style={getStyle(m, 'logo')} className='icon-myHealthSphere-logo' />
        </div>
    
        <Menu.Menu position='right'>
            {Boolean(props.rewardsEnable && !props.doneEnable && props.points!==null) &&
                <Link className="item" to="/leaderboards">
                    <div style={getStyle(m, 'pointsLink')}>
                        <div style={style.iconWrapper}>
                            <Icon style={style.pointsIcon} className="notClickable icon-star"/>
                        </div> 
                        {props.points} 
                    </div>
                </Link>
            }
            {Boolean(props.rewardsEnable && !props.doneEnable && props.resources!==null) &&
                <Link className="item" to="/rewards">
                    <div style={getStyle(m, 'resourcesLink')}>
                        <span style={style.iconWrapper}>
                            <Icon style={style.resourcesIcon} className='icon-Optimollar'/>
                        </span>
                        {props.resources}
                    </div>
                </Link>
            }
            {props.rewardsEnable && !props.doneEnable &&
                <Link className="item" to="/announcements">
                    <Icon style={getStyle(m, 'icon')} size="large" className='icon-news'/>
                    {Boolean(props.badgeNumbers.companyAnnouncementsBadge) &&
                    <Label style={getStyle(m, 'badgeNumber')} circular color='red' size='tiny'>{props.badgeNumbers.companyAnnouncementsBadge}</Label>
                    }
                </Link>
            }
            {props.doneButtonEnable &&
                <Menu.Item style={getStyle(m, 'item')} name='Done' onClick={props.onDone}>
                    {Boolean(props.doneIconOpts==null || (props.doneIconOpts.name!='' && props.doneIconOpts.className!='')) &&
                        <Icon style={getStyle(m, 'icon')} size='large' name={props.doneIconOpts ? props.doneIconOpts.name : 'checkmark'} className={props.doneIconOpts ? props.doneIconOpts.className : ''}/>
                    }
                    {props.doneIconOpts && props.doneIconOpts.label}
                </Menu.Item>
            }
        </Menu.Menu>
    </Menu>   
);

const NavBarMain = ({m, t, onClickLink, ...props}) => (
    <Menu className="NavBar NavBarMain" style={getStyle(m, 'menu')}>
        <a href='/home' style={getStyle(m, 'logoWrapper')} className='tablet or lower hidden hidden item' onClick={onClickLink}>
            <i style={getStyle(m, 'logo')} className='icon-myHealthSphere-logo' />
        </a>
        <div className='tablet or lower hidden' style={getStyle(m, 'verticalRule')}/>
        {props.menuEnable &&
            <Menu.Item style={getStyle(m, 'item')} className='tablet or mobile only' name='Menu' onClick={props.onClickMenuButton}>
                <Icon style={getStyle(m, 'icon', 'bold')} size='large' name={props.sideBarOpen ? 'x' : null} className={props.sideBarOpen ? null : 'icon-menu' }/>
            </Menu.Item>
        }
        {props.backButtonEnable && !props.closeButtonEnable &&
            <Menu.Item style={getStyle(m, 'item')} name='Back' onClick={props.onBack}><Icon style={getStyle(m, 'icon', 'bold')} size='large' name='chevron left'/></Menu.Item>
        }
        {props.closeButtonEnable &&
            <Menu.Item style={getStyle(m, 'item', 'closeItem')} name='Close' onClick={props.onClose}><Icon style={getStyle(m, 'icon', 'bold', 'closeIcon')} size='large' name={props.closeIconOpts ? props.closeIconOpts.name : 'x'} className={props.closeIconOpts ? props.closeIconOpts.className : ''}/></Menu.Item>
        }

        {props.links && 
            props.links.map(link => (
                <Menu.Item style={getStyle(m, 'item', 'textLink')} className='tablet or lower hidden' key={link.href} href={link.href} onClick={onClickLink}>{t(link.title)}</Menu.Item>
            ))
        }

    
        <Menu.Menu position='right'>
            <Link className="item" to="/announcements" onClick={onClickLink} style={getStyle(m, 'announcementsLink')}>
                <div>
                    {Boolean(props.badgeNumbers.companyAnnouncementsBadge) ? (
                        [
                        <div key='1' style={getStyle(m, 'badgeNumber')}>{props.badgeNumbers.companyAnnouncementsBadge}</div>,
                        <div key='2' style={getStyle(m, 'badgeNumberSpacer')}></div>
                        ]
                    ) : (
                        <div style={getStyle(m, 'bellIconWrapper')}>
                            <img style={style.bellIcon} src={bellIcon} alt='' />
                        </div> 
                    )}
                </div>
            </Link>
            {Boolean(props.rewardsEnable && !props.doneEnable && props.points!==null) &&
                <Link className='item tablet or lower hidden' to="/leaderboards" onClick={onClickLink}>
                    <div style={getStyle(m, 'pointsLink')}>
                        <div style={style.iconWrapper}>
                            <Icon style={style.pointsIcon} className="notClickable icon-star"/>
                        </div> 
                        {props.points} 
                    </div>
                </Link>
            }
            {Boolean(props.rewardsEnable && !props.doneEnable && props.resources!==null) &&
                <Link className='item tablet or lower hidden' to="/rewards" onClick={onClickLink}>
                    <div style={getStyle(m, 'resourcesLink')}>
                        <span style={style.iconWrapper}>
                            <Icon style={style.resourcesIcon} className='icon-Optimollar'/>
                        </span>
                        {props.resources}
                    </div>
                </Link>
            }


            <div className="tablet or lower hidden" style={{...getStyle(m, 'avatar'), backgroundImage:Utils.url(props.avatarUrl)}} onClick={props.onTogglePopUpMenu}>
                {props.showPopUpMenu &&
                    <PopUpMenuContainer {...props} 
                                m={m} 
                                t={t} 
                                onClickLink={onClickLink}
                                onClose={()=>props.onShowPopUpMenu(false)}/>
                }
            </div>            
        </Menu.Menu>
    </Menu>   
);


const NavBar = (props) => {
    if (!props.enable) {
        return null;
    }
    var m = props.mode;
    if(m === 'main') {
        return <NavBarMain {...props} m={m}/>;
    } else {
        return <NavBarLegacy {...props} m={m}/>;
    }
}

export default translate('sidebar')(NavBar);



// WEBPACK FOOTER //
// ./src/modules/navigation/NavBar.js